module.exports = __webpack_public_path__ + "assets/img/tx12g_4.6a8aa4f0.jpg";